import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';
import styles from './index.css';

import { Dialog } from '../../../../../components/modal';

import { classNames } from '@ifeng-fe/container_channel/common/client/utils/classnames';

class Rules extends React.PureComponent {
    static propTypes = {
        content: PropTypes.string,
    };

    /**
     * 插入html
     */

    handleClickRule = () => {
        Dialog.show({
            title: '活动规则',
            content: (
                <div className={styles.content}>
                    <div dangerouslySetInnerHTML={{ __html: this.props.content }} />
                </div>
            ),
        });
    };

    render() {
        return (
            <div className={classNames(styles.other, styles.rules)} onClick={this.handleClickRule}>
                评选规则说明
            </div>
        );
    }
}

const RulesChip = props => (
    <Chip id="161230" type="static" title="美食盛典-活动规则" groupName="正文-区域盛典" content={props.content}>
        <Rules />
    </Chip>
);

RulesChip.propTypes = {
    content: PropTypes.string,
};

export default errorBoundary(RulesChip);
